import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    region: [],
    state: [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    Tsm_Name: [],
    Spm_Name: [],
  },
  submitted: 0,
};

const RealizationFilterSlice = createSlice({
  name: "realizationfilter",
  initialState,
  reducers: {
    addFilters(state, action) {
      state.data = action.payload.data;
      state.submitted = action.payload.submitted;
    },
    applyFilters(state, action) {
      state.data = action.payload;
    },
    chgSubmitted(state, action) {
      state.submitted = action.payload;
    },
    resetFilters(state) {
      state.data = initialState.data;
      state.submitted = initialState.submitted;
    },
  },
});

export const { addFilters, applyFilters, chgSubmitted, resetFilters } =
  RealizationFilterSlice.actions;

export default RealizationFilterSlice.reducer;
